export default ($settings) => Object.assign({}, $settings)